import React from "react";
import { CSSProperties } from "@material-ui/styles";
import { Typography } from "./Typography";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";
import {
  Button,
  ClickAwayListener,
  MenuItem,
  MenuList,
  Popper,
} from "@mui/material";
import logo from "../asset/logo.png";
import logo2 from "../asset/simbridge_logo.png";
import MobileHeader from "./mobile/MobileHeader";
import { MobileWeb } from "../components/mobile/BreakPoint";

interface IHeaderMenu {
  children?: string;
  style?: CSSProperties;
  className?: string;
  color?: "primary";
}
const useStyles = makeStyles((theme: Theme) => ({
  // root: {
  //   color: "#EB4FE5",
  //   display: "block",
  //   maxWidth: 1440,
  //   height: 80,
  // },
  header: {
    width: 1440,
    height: 80,
    display: "flex",
    alignContent: "center",
    alignSelf: "center",
    justifyContent: "space-between",
    margin: "30px auto",
    "&:second-child": {
      marginRight: 42,
    },
    "&:third-child": {
      alignItems: "flex-end",
    },
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      display: "inline-block",
      margin: 0,
    },
  },
  menutab: {
    color: "#000",
  },
  logoWrap: {
    display: "flex",
  },
  logo: {
    marginRight: 30,
    // marginLeft: 115,
    // maxWidth: "169px",
    // width: "100%",
    display: "block",
    alignItems: "center",
    width: 200,
    height: "auto",
    // paddingBottom: 20,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  logo2: {
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "none",
    },
  },
  underline: {
    width: "140px",
    color: "#000",
    justifyContent: "center",
    marginTop: 1,
    marginBottom: 2,
  },
  menutext: {
    backgroundColor: "#FFF!important",
    justifyContent: "center",

    "&:hover": {
      color: "#EB4FE5",
    },
  },
  menulistwrap: {
    // marginTop: 10,
    // border: "1px solid black",

    padding: "5px auto",
    backgroundColor: "#fff",
    boxShadow: "0px 2px 15px rgba(0, 0, 0, 0.25)",

    "&:before": {
      content: '""',
      position: "absolute",
      top: -20,
      right: 42,
      borderBottom: "10px solid #fff",
      borderRight: "10px solid transparent",
      borderLeft: "10px solid transparent",
      borderTop: "10px solid transparent",
      zIndex: 10,
    },
  },
  headerwhite: {
    backgroundColor: "#FFF!important",
  },
  selected: {
    backgroundColor: "#EB4FE5!important",
  },
  mobileheader: {
    display: "none",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "flex",
    },
  },
  topmenu: {
    display: "flex",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "none",
    },
  },
}));

export const HeaderMenu = (props: IHeaderMenu) => {
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const [anchorEl2, setAnchorEl2] = React.useState<null | HTMLElement>(null);
  const [anchorEl3, setAnchorEl3] = React.useState<null | HTMLElement>(null);
  const [anchorEl4, setAnchorEl4] = React.useState<null | HTMLElement>(null);
  const [anchorEl5, setAnchorEl5] = React.useState<null | HTMLElement>(null);

  const open1 = Boolean(anchorEl1);
  const open2 = Boolean(anchorEl2);
  const open3 = Boolean(anchorEl3);
  const open4 = Boolean(anchorEl4);
  const open5 = Boolean(anchorEl5);

  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClick2 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClick3 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl3(event.currentTarget);
  };
  const handleClick4 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl4(event.currentTarget);
  };
  const handleClick5 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl5(event.currentTarget);
  };

  const handleClose1 = () => {
    setAnchorEl1(null);
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
  };
  const handleClose3 = () => {
    setAnchorEl3(null);
  };
  const handleClose4 = () => {
    setAnchorEl4(null);
  };
  const handleClose5 = () => {
    setAnchorEl5(null);
  };

  const classes = useStyles();

  return (
    <div className={classes.header}>
      <a href="/" className={classes.logoWrap}>
        <img src={logo} className={classes.logo} alt="logo" />
        <img src={logo2} className={classes.logo2} alt="logo2" />
      </a>
      <div className={classes.topmenu}>
        <Button
          disableRipple
          id="main-button1"
          aria-controls="main-menu1"
          aria-haspopup="true"
          aria-expanded={open1 ? "true" : undefined}
          onMouseEnter={handleClick1}
          onMouseLeave={handleClose1}
          sx={{
            marginRight: "42px",
            paddingTop: "10px",
            // padding: "0px",
            color: "#000",
            "&:hover": {
              color: "#EB4FE5",
            },
          }}
          classes={{
            root: classes.headerwhite,
            focusVisible: classes.selected,
          }}
          // endIcon={<KeyboardArrowDownIcon style={{ color: "#000" }} />}
        >
          <Typography variant="Body2">회사소개</Typography>
          <Popper
            id="main-menu1"
            anchorEl={anchorEl1}
            open={open1}
            className={classes.menulistwrap}
            onMouseLeave={handleClose1}
          >
            <ClickAwayListener onClickAway={handleClose1}>
              <MenuList>
                <MenuItem
                  onClick={handleClose1}
                  className={classes.menutext}
                  component="a"
                  href="/vision"
                  sx={{
                    justifyContent: "center",
                  }}
                >
                  비전&미션
                </MenuItem>
                <MenuItem
                  onClick={handleClose1}
                  className={classes.menutext}
                  component="a"
                  href="/history"
                  sx={{
                    justifyContent: "center",
                  }}
                >
                  연혁
                </MenuItem>
                <MenuItem
                  onClick={handleClose1}
                  className={classes.menutext}
                  component="a"
                  href="/team"
                  sx={{
                    justifyContent: "center",
                  }}
                >
                  팀구성
                </MenuItem>
                <MenuItem
                  onClick={handleClose1}
                  className={classes.menutext}
                  component="a"
                  href="/result"
                  sx={{
                    justifyContent: "center",
                  }}
                >
                  사업 성과
                </MenuItem>
                <MenuItem
                  onClick={handleClose1}
                  className={classes.menutext}
                  component="a"
                  href="/research"
                  sx={{
                    justifyContent: "center",
                  }}
                >
                  수상&연구
                </MenuItem>
              </MenuList>
            </ClickAwayListener>
          </Popper>
        </Button>

        <Button
          disableRipple
          id="main-button2"
          aria-controls="main-menu2"
          aria-haspopup="true"
          aria-expanded={open2 ? "true" : undefined}
          // onClick={handleClick2}
          onMouseEnter={handleClick2}
          onMouseLeave={handleClose2}
          classes={{
            root: classes.headerwhite,
            focusVisible: classes.selected,
          }}
          sx={{
            marginRight: "42px",
            color: "#000",
            // padding: "0px",
            alignItems: "flex-end",
            "&:hover": {
              color: "#EB4FE5",
            },
          }}
        >
          <Typography variant="Body2">
            심브릿지 시뮬레이션
            <hr className={classes.underline} />
            <p
              style={{
                fontSize: "10px",
                lineHeight: "0.1rem",
                textTransform: "none",
              }}
            >
              SimBridge
            </p>
          </Typography>
          <Popper
            id="main-menu2"
            anchorEl={anchorEl2}
            open={open2}
            className={classes.menulistwrap}
            // onMouseLeave={handleClose2}
          >
            <ClickAwayListener onClickAway={handleClose2}>
              <MenuList>
                <MenuItem
                  onClick={handleClose2}
                  className={classes.menutext}
                  component="a"
                  href="/simintro"
                  sx={{
                    justifyContent: "center",
                  }}
                >
                  사업소개
                </MenuItem>
                <MenuItem
                  onClick={handleClose2}
                  className={classes.menutext}
                  component="a"
                  href="/simfeature"
                  sx={{
                    justifyContent: "center",
                  }}
                >
                  특장점
                </MenuItem>
                <MenuItem
                  onClick={handleClose2}
                  className={classes.menutext}
                  component="a"
                  href="/simcontent"
                  sx={{
                    justifyContent: "center",
                  }}
                >
                  사업내용
                </MenuItem>
              </MenuList>
            </ClickAwayListener>
          </Popper>
        </Button>

        <Button
          disableRipple
          id="main-button3"
          aria-controls="main-menu3"
          aria-haspopup="true"
          aria-expanded={open3 ? "true" : undefined}
          // onClick={handleClick3}
          onMouseEnter={handleClick3}
          onMouseLeave={handleClose3}
          classes={{
            root: classes.headerwhite,
            focusVisible: classes.selected,
          }}
          sx={{
            marginRight: "42px",
            color: "#000",
            alignItems: "flex-end",
            "&:hover": {
              color: "#EB4FE5",
            },
          }}
        >
          <Typography variant="Body2">
            창업과 경영 교육과정
            <hr className={classes.underline} />
            <p
              style={{
                fontSize: "10px",
                lineHeight: "0.1rem",
                textTransform: "none",
              }}
            >
              MBA 4 RN
            </p>
          </Typography>
          <Popper
            id="main-menu3"
            anchorEl={anchorEl3}
            open={open3}
            onMouseLeave={handleClose3}
            className={classes.menulistwrap}
          >
            <ClickAwayListener onClickAway={handleClose3}>
              <MenuList>
                <MenuItem
                  onClick={handleClose3}
                  className={classes.menutext}
                  sx={{
                    justifyContent: "center",
                  }}
                  component="a"
                  href="/mba4intro"
                >
                  사업소개
                </MenuItem>
                <MenuItem
                  onClick={handleClose3}
                  className={classes.menutext}
                  sx={{
                    justifyContent: "center",
                  }}
                  component="a"
                  href="/mba4content"
                >
                  사업내용
                </MenuItem>
              </MenuList>
            </ClickAwayListener>
          </Popper>
        </Button>

        <Button
          disableRipple
          id="main-button4"
          aria-controls="main-menu4"
          aria-haspopup="true"
          aria-expanded={open4 ? "true" : undefined}
          // onClick={handleClick4}
          onMouseEnter={handleClick4}
          onMouseLeave={handleClose4}
          classes={{
            root: classes.headerwhite,
            focusVisible: classes.selected,
          }}
          sx={{
            marginRight: "42px",
            color: "#000",
            alignItems: "flex-end",
            "&:hover": {
              color: "#EB4FE5",
            },
          }}
        >
          <Typography variant="Body2">
            방문간호센터 경영솔루션
            <hr className={classes.underline} style={{ width: "165px" }} />
            <p
              style={{
                fontSize: "10px",
                lineHeight: "0.1rem",
                textTransform: "none",
              }}
            >
              3S-BIS
            </p>
          </Typography>
          <Popper
            id="main-menu4"
            anchorEl={anchorEl4}
            open={open4}
            onMouseLeave={handleClose4}
            className={classes.menulistwrap}
          >
            <ClickAwayListener onClickAway={handleClose4}>
              <MenuList>
                <MenuItem
                  onClick={handleClose4}
                  className={classes.menutext}
                  component="a"
                  href="/3sbisintro"
                  sx={{
                    justifyContent: "center",
                  }}
                >
                  사업소개
                </MenuItem>
                <MenuItem
                  onClick={handleClose4}
                  className={classes.menutext}
                  component="a"
                  href="/3sbiscontent"
                  sx={{
                    justifyContent: "center",
                  }}
                >
                  사업내용
                </MenuItem>
              </MenuList>
            </ClickAwayListener>
          </Popper>
        </Button>

        <Button
          disableRipple
          id="main-button5"
          aria-controls="main-menu5"
          aria-haspopup="true"
          aria-expanded={open5 ? "true" : undefined}
          // onClick={handleClick5}
          onMouseEnter={handleClick5}
          onMouseLeave={handleClose5}
          classes={{
            root: classes.headerwhite,
            focusVisible: classes.selected,
          }}
          sx={{
            marginRight: "42px",
            color: "#000",
            alignItems: "flex-end",
            "&:hover": {
              color: "#EB4FE5",
            },
          }}
        >
          <Typography variant="Body2">
            노인 돌봄 교육과정
            <hr className={classes.underline} />
            <p
              style={{
                fontSize: "10px",
                lineHeight: "0.1rem",
                textTransform: "none",
                marginRight: 0,
              }}
            >
              K Silver Care e-School
            </p>
          </Typography>
          <Popper
            id="main-menu5"
            anchorEl={anchorEl5}
            open={open5}
            onMouseLeave={handleClose5}
            className={classes.menulistwrap}
          >
            <ClickAwayListener onClickAway={handleClose5}>
              <MenuList>
                <MenuItem
                  onClick={handleClose5}
                  className={classes.menutext}
                  sx={{
                    justifyContent: "center",
                  }}
                  component="a"
                  href="/eldintro"
                >
                  사업소개
                </MenuItem>
                <MenuItem
                  onClick={handleClose5}
                  className={classes.menutext}
                  sx={{
                    justifyContent: "center",
                  }}
                  component="a"
                  href="/eldcontent"
                >
                  사업내용
                </MenuItem>
                <MenuItem
                  onClick={handleClose5}
                  className={classes.menutext}
                  sx={{
                    justifyContent: "center",
                  }}
                  component="a"
                  href="/eldcontent2"
                >
                  보도자료
                </MenuItem>
                <MenuItem
                  onClick={handleClose5}
                  className={classes.menutext}
                  sx={{
                    justifyContent: "center",
                  }}
                  component="a"
                  href="/eldcontent3"
                >
                  홍보영상
                </MenuItem>
              </MenuList>
            </ClickAwayListener>
          </Popper>
        </Button>
      </div>

      <div className={classes.mobileheader}>
        <MobileHeader />
      </div>
    </div>
  );
};
